package com.nnod.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Check
import androidx.compose.material.icons.outlined.ContentCopy
import androidx.compose.material3.Icon
import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.getValue
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.unit.dp
import com.nnod.ui.theme.NnodInputSurface
import com.nnod.ui.theme.NnodPurpleMid
import kotlinx.coroutines.Job
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch

@Composable
fun NnodCopyButton(
    onCopy: () -> Unit,
    accentColor: Color = NnodPurpleMid,
    modifier: Modifier = Modifier,
) {
    var copied by remember { mutableStateOf(false) }
    var resetJob by remember { mutableStateOf<Job?>(null) }
    val scope = rememberCoroutineScope()
    val shape = RoundedCornerShape(12.dp)

    Box(
        modifier = modifier
            .size(42.dp)
            .clip(shape)
            .background(if (copied) accentColor else NnodInputSurface)
            .border(1.5.dp, accentColor.copy(alpha = 0.2f), shape)
            .pointerHoverIcon(PointerIcon.Hand)
            .clickable {
                resetJob?.cancel()
                copied = true
                onCopy()
                resetJob = scope.launch {
                    delay(1500)
                    copied = false
                }
            },
        contentAlignment = Alignment.Center,
    ) {
        Icon(
            imageVector = if (copied) Icons.Filled.Check else Icons.Outlined.ContentCopy,
            contentDescription = null,
            tint = if (copied) Color.White else accentColor,
            modifier = Modifier.size(18.dp),
        )
    }
}
